import React, { useEffect, useState } from "react";
import BMInput from "../comps/BMInput";
import { Checkbox, Collapse, Button, Space, Divider, Input } from "antd";
import wrap from "../../utils/wrap"
import { TrashIcon, PlusIcon } from "../../admin/Icons";
import LinkUI from "./LinkUI";
export default function Buttons(props) {

    const { setData = () => { }, data = {} } = props;
    const [buttons, setButtons] = useState(props.buttons);
    const [selected, setSelected] = useState("");

    const save = () => {
        setData({...data, "buttons" : buttons});
    }

    useEffect(save, [buttons])

    const updateButton = (_key, _value, _index) => {
        let _arr = [...buttons];
        _arr[_index][_key] = _value;
        setButtons(_arr);
    }

    const removeButton = (_index) => {
        let _arr = [...buttons];
        _arr.splice(_index, 1);
        setButtons(_arr);
        setSelected("");
    }

    const addButton = () => {
        let _arr = [...buttons];
        _arr.push({
            label: "Button",
            link: "",
            tab: false
        });
        // Set to newly created button
        setSelected(_arr.length - 1);
        setButtons(_arr);
    }

    const selectButton = (_index) => {
        if (selected === _index) {
            setSelected("")
        } else {
            setSelected(_index)
        }
    }

    const drawButton = (_img = {}, _index) => {
        const { label = "", link = "", tab = false } = _img;
        return (
            <div>
                <Input className="input-fs" addonBefore={<div style={{"width" : "68px", "opacity" : ".6"}}><small>LABEL</small></div>} value={label} onChange={(e) => updateButton("label", e.target.value, _index)} />
                <LinkUI items={props?.items || []} anchor={true} value={link} onChange={(e) => updateButton("link", e, _index)} />
                <div className="float-flex">
                    <div>&nbsp;</div>
                    <div><Checkbox checked={(tab)} onChange={(e) => updateButton("tab", e.target.checked, _index)}><small>Open in new tab</small></Checkbox></div>
                </div>
            </div>
        )
    }

    const drawButtons = () => {
        return buttons.map((item, index) => {
            return (
                <Collapse.Panel extra={<>
                    <div style={{ "marginTop": "-2px" }}><Button onClick={() => removeButton(index)} type="link" icon={<TrashIcon />} size="small" /></div>
                </>} key={index} header={<div onClick={() => selectButton(index)} style={{ "marginTop": "-2px" }}><wrap.tags small color="#e77e21">BUTTON  {index+1}</wrap.tags></div>}>
                    {drawButton(item, index)}
                </Collapse.Panel>
            )
        })
    }

    return (
        <>
            <div className="float-flex">
                <div style={{ "width": "50px" }} orientationMargin={0} orientation="left" plain className="simple-divider ant-divider-with-text">BUTTONS</div>
                <div style={{ "marginTop": "-5px" }}><Button onClick={() => addButton()} type="link" icon={<PlusIcon />} size="small" /></div>
            </div>
            <Divider style={{ "margin": "5px 0px" }} dashed />
            <Collapse activeKey={selected} accordion className="subpanel" expandIcon={(e) => {
                let char =  (e.isActive) ? "-" : "+"; 
                return <div onClick={() => selectButton(e.panelKey)}>{char}</div>
               
            }} ghost>
                {drawButtons()}
            </Collapse>
        </>
    )
}